import { openTelegramLink } from '@telegram-apps/sdk-react';
import { miniAppLink } from '@debtbot/shared';
import { Button } from '../components/Button';
import { useT } from '../i18n';
import { BOT_USERNAME } from '../lib/bot-username';

/**
 * Mini App открыт из прежнего бота: API отвечает 410 BOT_MOVED на любой запрос (plugins/auth.ts).
 * Ведём в нового бота; deep link (inv_…, tx_…, c_…) сохраняем, чтобы открылся тот же экран.
 */
export function BotMovedScreen({ startParam }: { startParam: string | null }) {
  const t = useT();
  const link = startParam ? miniAppLink(BOT_USERNAME, startParam) : `https://t.me/${BOT_USERNAME}`;
  const open = () => {
    try {
      openTelegramLink(link);
    } catch {
      window.open(link, '_blank');
    }
  };
  return (
    <main className="min-h-dvh bg-bg text-text flex flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="text-5xl">🚚</div>
      <h1 className="text-xl font-semibold">{t.botMoved.title}</h1>
      <p className="text-hint">{t.botMoved.body(BOT_USERNAME)}</p>
      <Button onClick={open} data-testid="bot-moved-open">
        {t.botMoved.open}
      </Button>
    </main>
  );
}
